// src/pages/DirectMail/DirectMailRightDrawer.tsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";

import { moveItemsBetweenNodes } from "api/Campaigns/CampaignAPI";
import { getLinkedAddressesFromInteraction } from "api/Interactions/InteractionAPI";

interface DirectMailRightDrawerProps {
  directMailId: number;
}

const DirectMailRightDrawer: React.FC<DirectMailRightDrawerProps> = ({
  directMailId,
}) => {
  const theme = useTheme();

  // --------------------------------------------------
  // Fetch addresses attached to the Direct Mail interaction
  // --------------------------------------------------
  const fetchAddresses = async () => {
    const addresses = await getLinkedAddressesFromInteraction("direct_mail", directMailId);
    
    return addresses.map((p: any) => ({
      id: p.id,
      primary: `${p.street_address}, ${p.city}`,
      secondary: ` ${p.post_code}, ${p.country}`,
    }));
  };

  // --------------------------------------------------
  // Send direct mail = move addresses forward through pathway
  // --------------------------------------------------
  const handleSendDirectMail = async (selected: any[]) => {
    if (!selected.length) return;

    await moveItemsBetweenNodes({
      item_field_name: "addresses",
      selected_items: selected.map(p => p.id),
      handle_name: "output-10",
      direction: "forward",
      interaction_id: directMailId,
      interaction_type: "direct_mail",
    });

  };

  return (
    <ActionOnRecord
      fetchData={fetchAddresses}
      onAction={handleSendDirectMail}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Log Direct Mail"
    />
  );
};

export default DirectMailRightDrawer;
